import { BLOG_ASSET } from '../../Assets/assetImages';

const topics = [
  {
    id: 1,
    icon: BLOG_ASSET.education,
    title: 'Education',
    description: 'Content that emphasizes both theoretical and conceptual understanding',
  },
  {
    id: 2,
    icon: BLOG_ASSET.fitness,
    title: 'Fitness',
    description: 'Elevate your fitness journey to new heights with good content',
  },
  {
    id: 3,
    icon: BLOG_ASSET.payment,
    title: 'Payment',
    description: 'Discover secure ways to access new and optimized payment methods',
  },
  {
    id: 4,
    icon: BLOG_ASSET.savings,
    title: 'Savings',
    description: 'Unlock diverse saving strategies and enhance money management skills',
  },
  {
    id: 5,
    icon: BLOG_ASSET.shopping,
    title: 'Shopping',
    description: 'Revamp your cart with the freshest fashion trends of the season',
  },
  {
    id: 6,
    icon: BLOG_ASSET.technology,
    title: 'Technology',
    description: 'Explore the latest technologies to stay at the forefront of innovation',
  },
];

export default topics;
